import React, { useState, useEffect, Fragment } from 'react';
import axios from 'axios';
import DocsBcoChile from './DocsBcoChile';
import DocsCostaneraNorte from './DocsCostaneraNorte';
import DocsVespucioSur from './DocsVespucioSur';
import DocsCaja18 from './DocsCaja18';
import DocsVespucioNorte from './DocsVespucioNorte';
import DocsClaroMora from './DocsClaroMora';
import DocsClaroCastigo from './DocsClaroCastigo';
import DocsClaroPreventiva from './DocsClaroPreventiva';
import DocsForum from './DocsForum';
import DocsTanner from './DocsTanner';
import DocsRipley from './DocsRipley';
import DocsAIEP from './DocsAIEP';
import DocsAraucana from './DocsAraucana';
import DocsNuestrosParques from './DocsNuestrosParques';
import DocsClaroDicom from './DocsClaroDicom';
import DocsVtr from './DocsVtr';
import DocsCepech from './DocsCepech';

const ClientDocsList = (props) => {

    const [documents, setDocuments] = useState([]); 
    useEffect(() => {
       
      

        props.setDocumentsLength(props.client.documents.length);


    }, []);

    return (
        <Fragment>
            {props.companyId === 100 ? ( //COSTANERA NORTE
                <DocsCostaneraNorte clientCode={props.client.codCliente} documents={props.client.documents} debt={props.debt} setDebtFn={props.setDebtFn}/>
            ) : props.companyId === 103 ? ( //VESPUCIO SUR
                <DocsVespucioSur clientCode={props.client.codCliente} documents={props.client.documents} debt={props.debt} setDebtFn={props.setDebtFn}/>
            ) : props.companyId === 101 ? ( //BCOCHILE
                <DocsBcoChile documents={documents} debt={props.debt} setDebtFn={props.setDebtFn}/>
            ) : props.companyId === 150 ? ( //CAJA18
                <DocsCaja18 documents={documents} debt={props.debt} setDebtFn={props.setDebtFn}/>
            ) : props.companyId === 106 ? ( //VESPUCIO NORTE
                <DocsVespucioNorte clientCode={props.client.codCliente} documents={props.client.documents} debt={props.debt} setDebtFn={props.setDebtFn}/>
            ) : props.companyId === 107 ? ( //CLARO_MORA
                <DocsClaroMora clientCode={props.client.codCliente} documents={props.client.documents} debt={props.debt} setDebtFn={props.setDebtFn} />    
            ) : props.companyId === 108 ? ( //CLARO_CASTIGO
                <DocsClaroCastigo clientCode={props.client.codCliente} documents={props.client.documents} debt={props.debt} setDebtFn={props.setDebtFn} />    
            ) : props.companyId === 109 ? ( //CLARO_PREVENTIVA
                <DocsClaroPreventiva clientCode={props.client.codCliente} documents={props.client.documents} debt={props.debt} setDebtFn={props.setDebtFn} />    
            ) : props.companyId === 116 || props.companyId === 117 ? ( //FORUM
                <DocsForum clientCode={props.client.codCliente} documents={props.client.documents} debt={props.debt} setDebtFn={props.setDebtFn} setDocumentsLength={props.setDocumentsLength}/>    
            ) : props.companyId === 119 ? ( //TANNER
                <DocsTanner clientCode={props.client.codCliente} documents={props.client.documents} debt={props.debt} setDebtFn={props.setDebtFn} setDocumentsLength={props.setDocumentsLength}/>    
            ) : props.companyId === 120 ? ( //RIPLEY (NO CLONAR ESTE, porque es un componente especial que recibe props diferentes)
                <DocsRipley client={props.client} clientCode={props.client.codCliente} documents={props.client.documents} debt={props.debt} setDebtFn={props.setDebtFn} setDocumentsLength={props.setDocumentsLength} />
           ) : props.companyId === 121 || props.companyId === 122 ? ( //AIEP, CPECH 
                <DocsAIEP clientCode={props.client.codCliente} documents={props.client.documents} debt={props.debt} setDebtFn={props.setDebtFn} setDocumentsLength={props.setDocumentsLength}/>    
           ) : props.companyId === 123 ? ( //LA ARAUCANA
                <DocsAraucana clientCode={props.client.codCliente} documents={props.client.documents} debt={props.debt} setDebtFn={props.setDebtFn} setDocumentsLength={props.setDocumentsLength}/>    
           ) : props.companyId === 124 ? ( //Nuestros Parques
                <DocsNuestrosParques clientCode={props.client.codCliente} documents={props.client.documents} debt={props.debt} setDebtFn={props.setDebtFn} setDocumentsLength={props.setDocumentsLength} />
           ) : props.companyId === 125 ? ( //Claro Dicom
                <DocsClaroDicom clientCode={props.client.codCliente} documents={props.client.documents} debt={props.debt} setDebtFn={props.setDebtFn} setDocumentsLength={props.setDocumentsLength} />
           ) : props.companyId === 126 ? ( //VTR
                <DocsVtr clientCode={props.client.codCliente} documents={props.client.documents} debt={props.debt} setDebtFn={props.setDebtFn} setDocumentsLength={props.setDocumentsLength} />
           ) : props.companyId === 128 ? ( //CEPECH
                <DocsCepech clientCode={props.client.codCliente} documents={props.client.documents} debt={props.debt} setDebtFn={props.setDebtFn} setOfferFn={props.setOfferFn} setDocumentsLength={props.setDocumentsLength} />
           ) : null}
        </Fragment>
    );

}

export default ClientDocsList;